import { Alert, Checkbox, Text } from '@ui/themed';
import { t } from 'i18next';
import { useCustomerGroupsQuickSetupForm } from '../../hooks/use-customer-groups-quick-setup-form';
import { QUICK_SETUP_PAYMENT_METHODS } from '../../types/customer-group-quick-setup.schema';

export function PaymentMethodsField() {
  const form = useCustomerGroupsQuickSetupForm();

  return (
    <form.Field name="paymentMethods">
      {(field) => (
        <div className="flex flex-col gap-2">
          <Text>{t('features:customer_group.components.quick_setup.payment_methods.label')}</Text>
          {QUICK_SETUP_PAYMENT_METHODS.map((method) => (
            <Checkbox
              key={method}
              label={t(
                `features:customer_group.components.payment_methods_card.methods.${method}.label`,
              )}
              description={t(
                `features:customer_group.components.payment_methods_card.methods.${method}.description`,
              )}
              checked={field.state.value.includes(method)}
              onChange={() => {
                const current = field.state.value;

                // Toggle - add if not in list, remove if already in list
                field.handleChange(
                  current.includes(method)
                    ? current.filter((v) => v !== method)
                    : [...current, method],
                );
              }}
            />
          ))}
          {field.state.meta.errors[0] && (
            <Alert variant="error" headingLevel="h3">
              {field.state.meta.errors[0].message}
            </Alert>
          )}
        </div>
      )}
    </form.Field>
  );
}
